// extracted by mini-css-extract-plugin
export default {"wrapper":"CurrentPlanCard_wrapper__abWdk","price":"CurrentPlanCard_price__Qm8SK","flexColumn":"CurrentPlanCard_flexColumn__oci49"};